/**
 * Admin write schemas for WebsiteDestination (Phase 5 - CMS write API).
 *
 * countryCode is ISO-3166 alpha-2 or alpha-3 (2-3 chars). Validated by
 * length only; the master country table is a separate concern and these
 * rows are denormalized for the SEO landing pages.
 */

import { z } from 'zod';

import { UuidSchema } from './common.js';

export const CreateWebsiteDestinationRequestSchema = z.object({
  slug: z
    .string()
    .min(1)
    .max(200)
    .regex(/^[a-z0-9-]+$/u, 'Slug must be lowercase letters, digits, or dashes'),
  cityName: z.string().min(1).max(120),
  cityId: z.string().max(60).nullish(),
  cityCode: z.string().max(20).nullish(),
  countryName: z.string().min(1).max(120),
  countryCode: z.string().min(2).max(3),
  stateName: z.string().max(120).nullish(),
  isInternational: z.boolean().default(false),
  pageHeading: z.string().max(255).nullish(),
  pageContentHtml: z.string().max(200_000).nullish(),
  homeTileMediaId: UuidSchema.nullish(),
  innerBannerMediaId: UuidSchema.nullish(),
  sortOrder: z.number().int().min(0).default(0),
  isActive: z.boolean().default(true),
});
export type CreateWebsiteDestinationRequest = z.infer<typeof CreateWebsiteDestinationRequestSchema>;

export const UpdateWebsiteDestinationRequestSchema =
  CreateWebsiteDestinationRequestSchema.partial();
export type UpdateWebsiteDestinationRequest = z.infer<typeof UpdateWebsiteDestinationRequestSchema>;
